import 'whatwg-fetch';

import { AppConfig } from './appConfig';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createHashHistory } from 'history';
import { ResourceProvider } from './resourceProvider';
import Main from './main';
import configureStore from './configureStore';

const history = createHashHistory();
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

ResourceProvider.loadResources(AppConfig.GetResourceProviderApiUrl()).then(() => {
    ReactDOM.render(<Main store={store} history={history} />, document.getElementById('app'));
});
